// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3a2-8","head":"ProcedureTableInfo_head__118s7"};